import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import AssessmentIcon from '@material-ui/icons/Assessment';

export const observabilityRouteRef = createRouteRef();

const observabilityPage = PageBlueprint.make({
  params: {
    path: '/observability',
    title: 'Observability Centre',
    icon: <AssessmentIcon fontSize="inherit" />,
    routeRef: observabilityRouteRef,
    loader: async () => {
      const { ObservabilityPage } = await import('./ObservabilityPage');
      return <ObservabilityPage />;
    },
  },
});

export const observabilityPlugin = createFrontendPlugin({
  pluginId: 'datasphere-observability',
  extensions: [observabilityPage],
});
